
import axiosInstant from "../../axiosInstant";
import { getExhibition } from "../../Model/Auction";


export async function fetchCurrentExhibitions() {
  try {
    const results = await getExhibition();
    return Array.isArray(results) ? results : [];
  } catch (error) {
    console.error("Failed to load exhibitions:", error);
    return [];
  }
}


export async function fetchFavoriteLots(auctionId, userId) {
  if (!auctionId || !userId) return [];
  try {
    const res = await axiosInstant.get(
      `lot?auction_id=${auctionId}&search=&set_id=&page=1&cat=&fav=${userId}`
    );
    const rows = res?.data?.status === true ? res.data.msg : null;
    return Array.isArray(rows) ? rows : [];
  } catch (error) {
    console.error("Failed to load favourite lots:", error);
    return [];
  }
}
export async function fetchSettings(id) {
  if (!id) return null;

  try {
    const res = await axiosInstant.get(`settings?id=${id}`);

    console.log("SETTINGS RESPONSE:", res.data);

    const row =
      res?.data?.sucess === true
        ? res.data.data?.[0] || null
        : null;

    return row;
  } catch (error) {
    console.error("Failed to load settings", error);
    return null;
  }
}